module.exports = _.assign;